module.exports = __webpack_public_path__ + "img/floor2_10.a75d42a6.jpg";